const RANDOM_CODE_LENGTH = 6;

const normalizeCodePrefix = (name: string, fallback: string) => {
    const normalized = name
        .trim()
        .replace(/\s+/g, '_')
        .replace(/[^a-zA-Z0-9_-]+/g, '_')
        .replace(/_+/g, '_')
        .replace(/^_+|_+$/g, '');

    return normalized || fallback;
};

export const createComposerLocalCode = (name: string, fallback: 'attribute' | 'option') => {
    const randomSuffix = Math.random().toString(36).slice(2).padEnd(RANDOM_CODE_LENGTH, '0').slice(0, RANDOM_CODE_LENGTH);
    return `${normalizeCodePrefix(name, fallback)}_${randomSuffix}`;
};

export const isComposerStoreCode = (code: string | undefined | null) => {
    if (!code?.trim().startsWith('{')) return false;

    try {
        const parsed = JSON.parse(code);
        if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return false;

        return Boolean((typeof parsed.id === 'string' && parsed.id.trim()) || parsed.zakekePlatform === true);
    } catch {
        return false;
    }
};
